import { AgentService as OvermapAgentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AgentService extends OvermapAgentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
